import { api } from './../function/api.js';
import { get_cookie } from './../function/common.js';
import { set_map_state } from './../runtime/registerMap.js';
import { Trip, Editor, Search, User, Map, Cart, Content } from './../classes.js';


document.addEventListener("DOMContentLoaded", async function() {
	/****
	VARS
	****/
	const pathname = window.location.pathname;
	const query = window.location.search; 
	
		//Example: /t/tr_5m4t7X3NM
		//[0] => '', [1] 't', [1] 'tr_5m4t7X3NM'
	const path_array = pathname.split('/');
		
		//Example: const name = params.get('name');
	const params = new URLSearchParams(query);
		
		//Reserved keywords in the url to prevent known bad queries
	const reserved = [
		'create'
		, 'example'
	];	
	
	let data = new FormData();
	let response = {};
	let focus_user_map = true;
	let access_keys = get_cookie('jb_access_keys');
	
	
	
	/****
	CORE SYSTEM
	****/
	
	//homepage api triggers
	if(pathname === '/'){
		
		console.log('Run HOME API Queries');
	
	//else, we're on an internal page -- check if we are using any reserved keywords to identify if we should fire an API request
	}else{
		
		//path index 0 is "t", which means we're in the trip system
		if(path_array[1] === 't'){
			if(!reserved.includes(path_array[2])){
			
				console.log('Run SINGLE TRIP READ API Queries');
				data.append('slug', path_array[2]);
				data.append('secure', false);
				response = await api('/api/trip/read', data);
				
				//TRIP
				if(response.error){
					$('.trip__body').html('<h3 style="text-align:center">'+response.message.join('<br/>')+'</h3>');
					$('.trip__display').remove();
					
					//if an error and access, always show the invite box
					if(params.get('invite') && params.get('invite') == 'true'){
						$('#lightbox_confirm').css("display", "flex").hide().fadeIn(200);
					}
				}else{
					focus_user_map = false;
					
					Trip.set(response.data, true);
					
					if(params.get('invite') && params.get('invite') == 'true'){
						if(typeof(access_keys[response.data.content.trip.id]) == 'undefined'){
							$('#lightbox_confirm').css("display", "flex").hide().fadeIn(200);
						}
					}
				}
			}
			if(path_array[2] == 'create'){
				Trip.content = {};
				Trip.content.trip = {
					"name": ""
				};
				Editor.render();
			}
		}
		
		//path index 0 is "p", which means we're in the trip publication system
		if(path_array[1] === 'p'){
			if(!reserved.includes(path_array[2])){
			
				console.log('Run SINGLE TRIP READ API Queries');
				data.append('slug', path_array[2]);
				data.append('secure', true);
				response = await api('/api/trip/read', data);
				
				//TRIP
				if(response.error){
					$('.trip__body').html('<h3 style="text-align:center">'+response.message.join('<br/>')+'</h3>');
					$('.trip__display').remove();
				}else{
					focus_user_map = false;
					Trip.set(response.data);
				}
			}
		}
		
		//path index 0 is "explore", which means we're in the search system
		if(path_array[1] === 'explore'){
			focus_user_map = false;
			Search.set();
		}
		
		//path index 0 is "checkout", which means we're in the checkout/cart system
		if(path_array[1] === 'checkout'){
			console.log('Running Checkout');
			Cart.load();
			
		}
		
		//path index 0 is "explore", which means we're in the search system
		if(path_array[1] === 'u' || path_array[2] === 'signup'){
			set_map_state('active');
			
			if(path_array[2] === 'creator-dashboard'){
				console.log('load dashboard');
			}
		}
		
		
		if(window.content){
			if(path_array[1] === 'e'){
				Content.edit = true;
			}
			
			Content.load(path_array.at(-1));
		}
	
	}
	
	
	/****
	DOM Loaded and Classes Available, Check if we have a map that needs to be set.
	****/
	if(focus_user_map){
		if(Map && User.info.focus_lat != null && User.info.focus_lat != ''){
			//if we have a map and user specific data, update the map to the correct view
			Map.setView([User.info.focus_lat, User.info.focus_lng], User.info.focus_zoom);
		}
	}
});